import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-travel-wage-set-menu',
  templateUrl: './travel-wage-set-menu.component.html',
  styleUrls: ['./travel-wage-set-menu.component.css']
})
export class TravelWageSetMenuComponent implements OnInit {
    travelWageSetKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.travelWageSetKeyno = this.stateService.getStateParams()['travelwageset_keyno'];
    }

    private async loadMenu() {
        if (!!this.travelWageSetKeyno) {
            this.menu = (await this.datatask.Post(1495, { travelwageset_keyno: this.travelWageSetKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    travelwageset_keyno: number;
    travelwageset_name: string;
    valid_fom_dt: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelWageSetMenu', {
//        templateUrl: 'views/components/views/travelWageSetMenu/travelWageSetMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'travelWageSetMenuService', function ($stateParams, travelWageSetMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelWageSetKeyno = $stateParams.travelwageset_keyno;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadMenu = function () {
//                travelWageSetMenuService.getMenu({ travelwageset_keyno: travelWageSetKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.menu);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
